import { Loader } from '@lifebit-ai/lds'
import React from 'react'

import { LoadingContainer } from './AppLoadingSpinner.styles'

interface LoadingSpinnerProps {
  text?: string
  transparent?: boolean
}

const AppLoadingSpinner = ({ text, transparent }: LoadingSpinnerProps) => (
  <LoadingContainer transparent={transparent}>
    <Loader text={text ?? 'Loading…'} />
  </LoadingContainer>
)

export default AppLoadingSpinner
